module.exports = __webpack_public_path__ + "img/1438675837.01e1e643.jpg";